import { Wifi, Sparkles, Bell } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

// FIN-7 — EmptyConnectionsState
//
// Renderizado dentro de BancosList quando items=[]. Tem dois modos:
//
//   enabled=true (futuro):
//     "Conecte seu primeiro banco" + CTA "+" ativo.
//
//   enabled=false (atual, dormente):
//     "Em breve, conecte seu banco via Open Finance." + CTA "Quero ser
//     avisado" (toggle de notificação — fica como dívida-feature pra
//     próxima sessão se for prioridade).
//
// O empty state mora dentro do BancosList, então não duplica trust badges
// (que ficam no hero) — foco é convidar a ação.

export default function EmptyConnectionsState({ enabled = false, onAddBank }) {
  if (enabled) {
    return (
      <div
        className="text-center py-10 px-6"
        data-testid="conexoes-empty-active"
      >
        <div className="w-14 h-14 mx-auto rounded-full bg-brand-green/10 border border-brand-green/30 flex items-center justify-center mb-4">
          <Wifi className="w-6 h-6 text-brand-green" aria-hidden="true" />
        </div>
        <h4 className="text-h2 text-foreground mb-2">
          Conecte seu primeiro banco
        </h4>
        <p className="text-body text-foreground-muted max-w-sm mx-auto mb-5">
          Em poucos cliques, suas contas, faturas e investimentos passam a
          sincronizar sozinhos via Open Finance.
        </p>
        <Button
          type="button"
          onClick={onAddBank}
          className="bg-brand-green text-background hover:bg-brand-green/90 font-bold"
        >
          Adicionar banco
        </Button>
      </div>
    );
  }

  return (
    <div
      className="text-center py-10 px-6"
      data-testid="conexoes-empty-dormant"
    >
      <div className="w-14 h-14 mx-auto rounded-full bg-surface-card-hover border border-subtle flex items-center justify-center mb-4">
        <Sparkles className="w-6 h-6 text-foreground-muted" aria-hidden="true" />
      </div>
      <h4 className="text-h2 text-foreground mb-2">Em breve</h4>
      <p className="text-body text-foreground-muted max-w-sm mx-auto mb-5">
        A conexão automática via Open Finance será liberada no pré-lançamento.
        Enquanto isso, suas contas e cartões continuam funcionando em modo manual.
      </p>
      <div className="inline-flex items-center gap-2 px-4 py-2 rounded-lg border border-subtle bg-surface-card-hover text-foreground-muted text-caption">
        <Bell className="w-4 h-4" aria-hidden="true" />
        Vamos avisar quando ativarmos
      </div>
    </div>
  );
}
